import { createAsyncThunk } from '@reduxjs/toolkit';

import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import IEstelamMojadadShakhsSalesRequest from '../SakhsSalesBimehNameh/Commands/EstelamMojadadShakhsSales/IEstelamMojadadShakhsSalesRequest';
import { KhodroHttpPostService } from '../Services/KhodroHttpService';

export const estelamMojadadShakhsSalesKhodro = createAsyncThunk(
  'estelamMojadadShakhsSalesKhodro',
  async (command: IEstelamMojadadShakhsSalesRequest) => {
    return await KhodroHttpPostService({
      url: `${_apiPathManagerConfig?.Khodro.BimehNamehHayeShakhsSales.EstelamMojadadShakhsSalesKhodro}`,
      body: command,
    });
  }
);
